import React from 'react';

const ErrorMessagePopup = ({ message, subMessage, isVisible, onClose, customPosition, popupType = 'error' }) => {
  if (!isVisible) return null;

  // Default position (for train model popup)
  const defaultPosition = {
    top: '75%',
    left: '50%'
  };

  // Custom position for validation popups (like interchange selection)
  const validationPosition = {
    top: '60%',
    left: '57%'
  };

  const position = customPosition === 'validation' ? validationPosition : defaultPosition;

  // Determine if close button should be shown and border color
  const showCloseButton = popupType !== 'validation';
  const borderColor = popupType === 'success' ? '#ff6600' : '#ff6600';
  const backgroundColor = popupType === 'success' ? 'white' : 'white';

  return (
    <div style={{
      position: 'fixed', // Changed from 'absolute' to 'fixed'
      top: position.top,
      left: position.left,
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      zIndex: 9999, // Increased z-index to ensure it appears above everything
      background: backgroundColor,
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.2)', // Increased shadow for better visibility
      width: '400px',
      minHeight: '120px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      border: `2px solid ${borderColor}` // Dynamic border color based on popup type
    }}>
      <div style={{
        fontSize: '16px',
        color: popupType === 'success' ? '#666' : '#666',
        fontWeight: '500',
        lineHeight: '1.4'
      }}>
        {message}
      </div>
      {subMessage && (
        <div style={{
          fontSize: '14px',
          color: popupType === 'success' ? '#999' : '#999',
          marginTop: '8px'
        }}>
          {subMessage}
        </div>
      )}
      {showCloseButton && onClose && (
        <button
          onClick={onClose}
          style={{
            marginTop: '16px',
            padding: '8px 16px',
            backgroundColor: popupType === 'success' ? '#ff6600' : '#ff6600',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Close
        </button>
      )}
    </div>
  );
};

export default ErrorMessagePopup; 